import axios from 'axios';
import { getAccess, getRefresh, setAccess, clearTokens } from '../auth/storage';

export const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((cfg) => {
  const token = getAccess();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Pending Refresh: verhindert parallele Refresh-Requests bei 401-Schwärmen
let refreshing = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && getRefresh()) {
      original._retry = true;
      if (!refreshing) {
        refreshing = axios
          .post('/api/auth/refresh', null, {
            headers: { Authorization: `Bearer ${getRefresh()}` },
          })
          .then((res) => {
            setAccess(res.data.access);
            return res.data.access;
          })
          .catch((e) => {
            clearTokens();
            throw e;
          })
          .finally(() => {
            refreshing = null;
          });
      }
      try {
        const newAccess = await refreshing;
        original.headers.Authorization = `Bearer ${newAccess}`;
        return api(original);
      } catch (_) {
        window.location.href = '/login';
      }
    }
    throw error;
  }
);
